"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatadogProvider = void 0;
const browser_logs_1 = require("@datadog/browser-logs");
class DatadogProvider {
    init(config) {
        try {
            // https://docs.datadoghq.com/logs/log_collection/javascript/
            browser_logs_1.datadogLogs.init({
                clientToken: config.credentials.clientToken,
                service: config.service,
                version: config.version,
                forwardErrorsToLogs: false,
                sessionSampleRate: 100,
                telemetrySampleRate: 0, // opt out from telemetry collection
            });
            browser_logs_1.datadogLogs.setGlobalContext({
                dp_env: config.env,
            });
        }
        catch (error) {
            console.error("Unable to initialize datadog", error);
        }
    }
    cleanup() { }
    setUser(user) {
        try {
            browser_logs_1.datadogLogs.setUser(user);
        }
        catch (error) {
            console.error("Unable to set user", error);
        }
    }
    setUserProperty(key, value) {
        try {
            browser_logs_1.datadogLogs.setUserProperty(key, value);
        }
        catch (error) {
            console.error("Unable to set property on user", error);
        }
    }
    recordInfo(message, messageContext) {
        try {
            browser_logs_1.datadogLogs.logger.info(message, messageContext);
        }
        catch (error) {
            console.error("Unable to record info", error);
        }
    }
    recordWarn(message, messageContext, error) {
        try {
            browser_logs_1.datadogLogs.logger.warn(message, messageContext, error);
        }
        catch (error) {
            console.error("Unable to record warning", error);
        }
    }
    recordError(message, error, messageContext) {
        try {
            browser_logs_1.datadogLogs.logger.error(message, messageContext, error);
        }
        catch (error) {
            console.error("Unable to record error", error);
        }
    }
}
exports.DatadogProvider = DatadogProvider;
